import * as ko from "knockout"
import {IImportHrFile, IMessageData, ICompany} from "../../../index"
import {REQUEST_MESSAGE, PLEASE_WAIT_MESSAGE} from "../../../constants/Language";
import PromiseRequest from "../../../req/PromiseRequest"
import {createErrorMessage} from "../../../util/misc";
import {ButtonManager} from "../../../util/ButtonManager";
import {getCancelButton, getSubmitButton} from "../../../constants/RouteDefinitions";
import {IDialogOptionsComponent} from "../../dialog/index";
import send_end_reportHtml from './send-end-report.html?raw';

export const template = send_end_reportHtml

interface IParams {
    importfile: IImportHrFile
    dialog: IDialogOptionsComponent
}

enum Step {
    Ready = 'ready',
    Success = 'success',
}

export class viewModel {

    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    private readonly req_getcompany: PromiseRequest = new PromiseRequest('getcompany')
    private readonly req_sendendreport: PromiseRequest = new PromiseRequest('sendendreport')
    private syncendreportrecipients: string[] | null = null
    private readonly isReady: KnockoutObservable<boolean> = ko.observable(false)
    private readonly importfile: IImportHrFile
    private readonly step: KnockoutObservable<Step | null> = ko.observable(null)
    private readonly Step = Step
    private isSendCompleted: KnockoutObservable<boolean> = ko.observable(false)
    private readonly pageButtons: ButtonManager = new ButtonManager()

    constructor(private params: IParams) {
        this.importfile = params.importfile

        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.()))
        this.pageButtons.add(getSubmitButton({
            label: 'Send',
            onClick: () => this.onSendClick(),
            enabled: () => this.isReady(),
            validator: () => !this.isSendCompleted(),
        }))

        this.init()
    }

    private init() {
        this.messageData({message: REQUEST_MESSAGE})
        this.isReady(false)
        return this.req_getcompany
            .request()
            .then((data: [ICompany]) => {
                const recipients = data[0].syncendreportrecipients
                this.syncendreportrecipients = recipients.split(',')
                this.step(Step.Ready)
                this.messageData(null)
                this.isReady(true)
            })
    }

    private onSendClick() {
        this.messageData({message: PLEASE_WAIT_MESSAGE})
        this.isReady(false)
        this.req_sendendreport.request({
            importfile: this.importfile.id,
        })
        .then(() => {
            this.step(Step.Success)
            this.messageData(null)
            this.isReady(true)
            this.isSendCompleted(true)
        })
        .catch((reason: string) => {
            this.messageData(createErrorMessage(String(reason)))
        })

    }

    dispose() {
        this.req_getcompany.abort()
        this.req_sendendreport.abort()
    }

}
